import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import '@angular/common/locales/global/pl';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { MatButtonModule } from '@angular/material/button';
import { ScanQrcodeModule } from './scan-qrcode/scan-qrcode.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ErrorPagesComponent } from './error-pages/error-pages.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppErrorService } from './services/app-error.service';
import { PayReturnComponent } from './pay-return/pay-return.component';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CookiesInfoComponent } from './cookies-info/cookies-info.component';
// import { VerifyTokenComponent } from './verification/verify-token/verify-token.component';


@NgModule({
  declarations: [
    AppComponent,
    // MainDashboardComponent,
    ErrorPagesComponent,
    PayReturnComponent,
    CookiesInfoComponent
    // VerifyTokenComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatSnackBarModule,
    ScanQrcodeModule,
    FlexLayoutModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    CookieService,
    { provide: LOCALE_ID, useValue: "pl" },
    { provide: ErrorHandler, useClass: AppErrorService } // add global error handler
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
